// extracted by mini-css-extract-plugin
export var desc = "card-module--desc--52d4d";
export var icon = "card-module--icon--483d6";
export var title = "card-module--title--69d11";
export var wrapper = "card-module--wrapper--e8704";